import React, { useEffect, useState } from 'react';
import { analyticsHelpers, Button, Dialog, FormWrap, Input, toast, formattingHelpers } from 'day8-ui';
import confetti from 'canvas-confetti';
import { FaLock } from "@react-icons/all-files/fa/FaLock";
import { useInvitationModal } from '../../context/InvitationModalContext';
import { getQuery } from '../../helpers/querystring';
var GA4_TRIGGERS = analyticsHelpers.GA4_TRIGGERS;
var InvitationModal = function () {
    var _a = useInvitationModal(), isModalOpen = _a.isModalOpen, close = _a.close, setCanContinue = _a.setCanContinue, modalProps = _a.modalProps;
    var _b = useState(''), email = _b[0], setEmail = _b[1];
    var _c = useState(false), submitting = _c[0], setSubmitting = _c[1];
    var _d = useState(''), inputText = _d[0], setInputText = _d[1];
    useEffect(function () {
        var query = getQuery(window.location);
        var queryCode = query.ic || '';
        setInputText(queryCode);
    }, []);
    if (!(modalProps === null || modalProps === void 0 ? void 0 : modalProps.emailSignupData)) {
        return null;
    }
    var sendCode = function (e) {
        setSubmitting(true);
        e.preventDefault();
        var code = inputText;
        fetch("/api/yl/apply-code", {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: code
            })
        })
            .then(function (response) { return response.json(); })
            .then(function (json) {
            setInputText('');
            setCanContinue(json.status === 'success');
            if (json.status === 'success') {
                toast.success('Code applied successfully');
                var seconds = 2;
                var end_1 = Date.now() + (seconds * 1000);
                var interval_1 = setInterval(function () {
                    if (Date.now() > end_1) {
                        return clearInterval(interval_1);
                    }
                    return confetti({
                        startVelocity: 30,
                        spread: 360,
                        ticks: 60,
                        shapes: ['square'],
                        origin: {
                            x: Math.random(),
                            // since they fall down, start a bit higher than random
                            y: Math.random() - 0.2
                        }
                    });
                }, 200);
                setEmail('');
                close();
            }
            else {
                toast.error(json.message);
            }
        })
            .catch(function (ex) {
            console.log('failed sending code', ex);
            toast.error('Failed sending code');
        }).finally(function () {
            setSubmitting(false);
        });
    };
    var handleMarketingSubmit = function (e) {
        var _a;
        e.preventDefault();
        var isEmailValid = formattingHelpers.validateEmail(email);
        if (!isEmailValid) {
            return toast.error('Please enter a valid email address');
        }
        setSubmitting(true);
        if (!((_a = modalProps.emailSignupData) === null || _a === void 0 ? void 0 : _a.addressBookId)) {
            return toast.error('Something went wrong, please try again later');
        }
        fetch('/api/marketing/add-contact', {
            method: 'POST',
            body: JSON.stringify({
                addressBookId: modalProps.emailSignupData.addressBookId,
                email: email.trim()
            }),
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(function (response) { return response.json(); })
            .then(function (response) {
            if (response.status === 'success') {
                analyticsHelpers.contactSubscribe({ email: email });
                toast.success('Thank you for subscribing!');
                setEmail('');
                close();
            }
            else {
                toast.error("Something went wrong, please try again later");
            }
        })
            .catch(function () {
            toast.error("Something went wrong, please try again later");
        })
            .finally(function () {
            setSubmitting(false);
        });
    };
    return (React.createElement(Dialog, { open: isModalOpen, onOpenChange: close, title: React.createElement("h2", { className: "dui-text-2xl dui-flex dui-items-center dui-gap-2 dui-mb-4" },
            React.createElement(FaLock, null),
            "Bookings Open Soon"), scrollable: true },
        React.createElement("p", { className: 'dui-mb-4' }, "Get first access - let us notify you at booking opening."),
        (modalProps === null || modalProps === void 0 ? void 0 : modalProps.emailSignupData) && (React.createElement(React.Fragment, null,
            React.createElement(FormWrap, { id: GA4_TRIGGERS.SIGNUP_FORM_ID, onSubmit: handleMarketingSubmit },
                React.createElement("div", { className: "dui-flex dui-items-center dui-justify-between dui-gap-4" },
                    React.createElement(Input, { name: "email", type: "text", value: email, placeholder: "Enter your email here", onChange: function (e) { return setEmail(e.target.value); } }),
                    React.createElement(Button, { className: 'dui-shrink-0', type: "submit", disabled: submitting }, submitting ? 'Submitting...' : 'Notify me'))),
            React.createElement("p", { className: 'dui-my-4 dui-text-center dui-font-bold' }, "OR"))),
        React.createElement("p", { className: 'dui-mb-4' }, "If you have a pre-booking code, enter it here."),
        React.createElement(FormWrap, { id: GA4_TRIGGERS.INVITATION_CODE_FORM_ID, onSubmit: sendCode },
            React.createElement("div", { className: "dui-flex dui-items-center dui-justify-between dui-gap-4" },
                React.createElement(Input, { name: "code", type: "text", value: inputText, placeholder: "Enter your code here...", onChange: function (e) { return setInputText(e.target.value); } }),
                React.createElement(Button, { type: "submit", disabled: submitting }, submitting ? 'Applying...' : 'Apply')))));
};
export default InvitationModal;
